
import Vue from "vue";
import { maska } from "maska";
import { phoneMask } from "./mask.utils";
import { formatPhone } from "./format.utils";

export default Vue.extend({
  name: "PhoneInput",

  directives: { maska },

  props: {
    value: String,
    label: { type: String, required: true },
    error: String,
    disabled: Boolean,
    loading: Boolean,
    hidedetails: {
      default: "auto",
    },
    dense: {
      default: false,
    },
    hint: {
      type: String,
    },
    required: {
      type: Boolean
    },
    rules: {
      type: Array
    }
  },

  data: () => ({
    formattedValue: "",
  }),

  computed: {
    mask: () => phoneMask,

    hasErrors(): boolean {
      return this.error?.length > 0;
    },
  },

  methods: {
    onMask(event: any) {
      this.$emit("input", event.target.dataset.maskRawValue);
    },
  },

  watch: {
    value(newValue: string) {
      if (!newValue) {
        (this.formattedValue as any) = null;
        return;
      }

      this.formattedValue = formatPhone(newValue || "");
    },
  },

  created() {
    this.formattedValue = this.value;
  },
});
